import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from './styles.scss'
import { getYearOptions, getWeekRange, getMonthDay, getNumberOfWorkWeeksInYear } from 'helpers/DateUtil'
import Input from 'components/fulcrum/input/Input'
import Dropdown from 'components/fulcrum/dropdown/FulcrumDropdown'

class WeekSelection extends Component {
  constructor(props){
    super(props)
    this.yearOptions = getYearOptions()
    this.numWeeksInYear = this.getWeeksInYear(props.year)
  }

  shouldComponentUpdate(nextProps){
    return (this.props.week != nextProps.week || this.props.year != nextProps.year)
  }

  getWeeksInYear(year){
    if(year){
      return getNumberOfWorkWeeksInYear(year)
    }
    return 0
  }

  updateYear(newYear){
    this.props.updateYear(newYear)
    this.getWeeksInYear(newYear)
  }

  updateWeek(newWeek){
    if((newWeek >= 1 && newWeek <= this.numWeeksInYear) || newWeek === ''){
      this.props.updateWeek(newWeek)
    }
  }

  getDates(){
    const {
      week,
      year, 
    } = this.props
    if(week === '') return ''
    const range = getWeekRange(week, year)
    return getMonthDay(range.first) + ' - ' + getMonthDay(range.last)
  }

  render(){
    const {
      week,
      year, 
    } = this.props

    return (
      <div styleName='weekSelectionContainer'>
        <div styleName='weekSelector'>
          <div>Week</div>
          <Input type='number' value={week} onChange={(newWeek) => this.updateWeek(newWeek)} />
        </div>
        <div styleName='yearSelector'>
          <div>Year</div>
          <Dropdown value={year} source={this.yearOptions} onChange={(newYear) => this.updateYear(newYear)} />
        </div>
        <div>
          <div styleName='datesHeader'>Dates</div>
          <div styleName='datesValue'>{this.getDates()}</div>
        </div>
      </div>
    )
  }
}

export default CSSModules(styles)(WeekSelection)